<template>
    <div class="password-login-container">
        <div class="container">
            <CodeScannerGeneric @codeScanned="handleCodeScanned" />

            <div class="form">
                <div class="config-item">
                    <div class="label-container">
                        <label for="consumer" v-text="getString('consumidor')"></label>
                    </div>
                    <div id="consumer" ref="consumerDiv" class="div-input-android"
                        :class="{ 'active-input': isTheActiveInput('consumerDiv') }"
                        @click="switchActiveInput('consumerDiv')" data-clarity-mask="true">
                    </div>
                </div>

                <div class="config-item">
                    <div class="label-container">
                        <label for="password" v-text="getString('senha')"></label>
                    </div>
                    <div id="password" ref="passwordDiv" class="div-input-android"
                        :class="{ 'active-input': isTheActiveInput('passwordDiv') }"
                        @click="switchActiveInput('passwordDiv')" data-clarity-mask="true">
                    </div>
                </div>
            </div>

            <div class="message-container">
                <p v-text="message.text" :class="message.type"></p>
            </div>

            <div class="password-actions-row">
                <div class="controls-buttons">
                    <DefaultButton v-if="controlsEnabled" :text="getString('confirmar')"
                        @defaultBtnClick="loginWithPassword()">
                    </DefaultButton>
                    <DefaultButton v-else :text="getString('aguarde')" :disabled="true">
                    </DefaultButton>
                    <DefaultButton :text="getCancelText()" :outlined="true"
                        @defaultBtnClick="cancelLogin()">
                    </DefaultButton>
                </div>

                <AndroidKeyboard id="android-keyboard"
                    :inputElement="inputElement"
                    :layout="layout"
                    :isPasswordField="isPasswordField"
                    @passwordCharacterTyped="passwordCharacterTyped"
                    @passwordCharacterErased="passwordCharacterErased"
                    @passwordFieldCleaned="passwordFieldCleaned">
                </AndroidKeyboard>

                <div class="new-password-container">
                    <DefaultButton class="new-login-button" :text="getString('cadastrar_nova_senha')"
                        v-if="controlsEnabled"
                        @defaultBtnClick="openNewPasswordModal()">
                    </DefaultButton>
                </div>
            </div>
        </div>

        <div class="inner-overlay" v-if="showNewPasswordModal" @click="closeNewPasswordModal()"></div>
        <NewPasswordModal v-if="showNewPasswordModal" @closeNewPasswordModal="closeNewPasswordModal()"
            @disableOverlayClick="overlayClickEnabled = false" @enableOverlayClick="overlayClickEnabled = true">
        </NewPasswordModal>
    </div>
</template>

<script>
import md5 from 'md5'
import DefaultButton from '@/components/DefaultButton'
import IdentifiedConsumerController from '@/assets/controllers/IdentifiedConsumerController'
import NewPasswordModal from '@/components/NewPasswordModal'
import LocaleController from '@/assets/controllers/LocaleController'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import CodeScannerGeneric from '@/components/CodeScannerGeneric.vue'

export default {
    name: 'ConsumerLoginPassword',
    components: {
        DefaultButton,
        NewPasswordModal,
        AndroidKeyboard,
        CodeScannerGeneric
    },
    data () {
        return {
            inputElement: null,
            layout: keyboardLayout.LOGIN_AND_PASSWORD,
            isPasswordField: false,
            rawConsumer: null,
            rawPassword: '',
            consumer: null,
            password: null,
            controlsEnabled: true,
            showNewPasswordModal: false,
            overlayClickEnabled: true,
            message: {
                text: '',
                type: 'info'
            }
        }
    },
    mounted () {
        this.inputElement = this.$refs.consumerDiv
        this.fillConsumerId()
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        isTheActiveInput: function (divReference) {
            return this.inputElement === this.$refs[divReference]
        },
        switchActiveInput: function (divReference) {
            this.inputElement = this.$refs[divReference]
            this.isPasswordField = this.inputElement === this.$refs.passwordDiv
        },
        passwordCharacterTyped: function (key) {
            this.rawPassword += key
        },
        passwordCharacterErased: function () {
            this.rawPassword = this.rawPassword.slice(0, -1)
        },
        passwordFieldCleaned: function () {
            this.rawPassword = ''
        },
        fillConsumerId: function () {
            try {
                if (IdentifiedConsumerController.userIsLogged()) {
                    setTimeout(() => {
                        let consumerData = IdentifiedConsumerController.getConsumerData()
                        this.rawConsumer = consumerData.consumerId
                        this.$refs.consumerDiv.innerText = this.rawConsumer
                    }, 500)
                }
            } catch (e) {
                console.log(e)
            }
        },
        handleCodeScanned: function (code) {
            if (this.isTheActiveInput('consumerDiv')) {
                this.rawConsumer = code
                this.$refs.consumerDiv.innerText = ''
                this.$refs.consumerDiv.innerText = this.rawConsumer
                this.switchActiveInput('passwordDiv')
            } else if (this.isTheActiveInput('passwordDiv')) {
                this.rawPassword = code
                this.$refs.passwordDiv.innerText = ''
                this.$refs.passwordDiv.innerText = this.rawPassword.replace(/\w/g, '*')
                this.loginWithPassword()
            }
        },
        validateInputs: function () {
            let result = { isValid: true, message: '' }

            if (this.rawConsumer == null || this.rawPassword == null) {
                result.isValid = false
                result.message = this.getString('todos_campos_obrigatorios')
                return result
            }

            this.consumer = this.rawConsumer.trim()
            this.password = this.rawPassword.trim()

            let consumerIsEmpty = this.consumer.length === 0
            let passwordIsEmpty = this.password.length === 0

            if (consumerIsEmpty || passwordIsEmpty) {
                result.isValid = false
                result.message = this.getString('todos_campos_obrigatorios')
                return result
            }

            return result
        },
        loginWithPassword: async function () {
            if (!this.controlsEnabled) return

            this.rawConsumer = this.$refs.consumerDiv.innerText

            let inputResult = this.validateInputs()
            if (!inputResult.isValid) {
                this.message.text = inputResult.message
                this.message.type = 'error'
                return
            }

            this.controlsEnabled = false
            this.$emit('disableOverlayClick')
            let md5Password = this.password === '' ? this.password : md5(this.password)

            this.message.text = this.getString('aguarde_enquanto_realizamos_o_login')
            this.message.type = 'info'
            let loginResponse = await IdentifiedConsumerController.loginWithPassword(this.rawConsumer, md5Password)

            if (loginResponse && loginResponse.success) {
                this.message.text = this.getString('login_realizado_com_sucesso')
                this.message.type = 'success'
                this.$emit('loginSuccess')
                return
            } else if (loginResponse) {
                this.message.text = loginResponse.message
                this.message.type = 'error'
            } else {
                this.message.text = this.getString('houve_erro_ao_realizar_login')
                this.message.type = 'error'
            }

            setTimeout(() => {
                // if (this.$refs.consumerDiv) this.$refs.consumerDiv.innerText = ''
                if (this.$refs.passwordDiv) this.$refs.passwordDiv.innerText = ''
                // this.rawConsumer = null
                this.rawPassword = ''
                this.switchActiveInput('consumerDiv')
            }, 200)

            this.controlsEnabled = true
            this.$emit('enableOverlayClick')
        },
        openNewPasswordModal: function () {
            this.showNewPasswordModal = true
        },
        closeNewPasswordModal: function () {
            if (this.overlayClickEnabled) {
                this.showNewPasswordModal = false
            }
        },
        cancelLogin: function () {
            IdentifiedConsumerController.userLogout()
            IdentifiedConsumerController.clearConsumerData()
            this.$emit('cancelLogin')
        },
        getCancelText: function () {
            return this.$router.currentRoute.name === 'Payment' ? this.getString('cancelar') : this.getString('nao_quero_identificar')
        }
    }
}
</script>

<style scoped lang='less'>
@import (reference) url("../../assets/common.less");

.password-login-container {
    flex: 1 1 0%;
    min-height: 0;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    .container {
        flex: 1 1 0%;
        min-height: 0;
        min-width: 0;
        overflow-x: hidden;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;

        .form {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;

            .config-item {
                display: flex;
                flex-direction: column;
                align-items: start;
                justify-content: space-between;

                label {
                    font-size: 30px;
                    position: relative;
                    display: inline-block;
                    margin: 10px 0 20px 0;
                }

                .div-input-android {
                    position: relative;
                    display: flex;
                    align-items: center;
                    font-size: 2.2rem;
                    min-height: 40px;
                    height: 70px;
                    background: rgb(241, 241, 241);
                    color: #222;
                    border: 2px solid rgb(187, 187, 187);
                    padding: 0 20px;
                    width: 100%;
                    box-sizing: border-box;
                    border-radius: 10px;
                    transition: all 0.2s ease;
                }

                .active-input {
                    transform: scale(1.01);
                    border-bottom: 3px solid @primary-color;
                }
            }
        }

        .message-container {
            min-height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 10px 0;

            p {
                font-size: 30px;
                text-align: center;
                margin: 0;

                &.error {
                    color: #d32f2f;
                }

                &.success {
                    color: #388e3c;
                }

                &.info {
                    color: #1565c0;
                }
            }
        }

        .password-actions-row {
            display: block;

            .controls-buttons {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin: 20px auto;
                width: 100%;

                button {
                    width: 50%;
                    margin: 0 10px;
                }
            }

            #android-keyboard {
                margin: 0;
            }

            .new-password-container {
                display: flex;
                justify-content: center;
                margin: 30px 0;
            }
        }
    }
}

.inner-overlay {
    z-index: 4;
    .full;
    content: '';
    background: black;
    opacity: .5;
    pointer-events: auto;
}

@media (min-width: 699px) and (max-width: 1025px) {
    .password-login-container {
        .container {
            .form {
                .config-item {
                    margin-bottom: 10px;
                    label {
                        font-size: 28px;
                        margin: 10px 0 10px 0;
                    }

                    .div-input-android {
                        font-size: 2rem;
                        height: 65px;
                    }
                }
            }

            .message-container {
                min-height: 20px;
                max-height: 40px;
                height: auto;
                margin: 10px 0;
                font-size: 25px;
            }

            .password-actions-row {
                .controls-buttons {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    margin: 20px auto;
                    width: 100%;
                }

                .new-password-container {
                    display: flex;
                    justify-content: center;
                    margin: 30px 0;
                }
            }
        }
    }
}

@media (max-width: 698px) {
    .password-login-container {
        .container {
            .form {
                .config-item {
                    margin-bottom: 10px;
                    label {
                        font-size: 20px;
                        margin: 5px 0 5px 0;
                    }

                    .div-input-android {
                        font-size: 1.2rem;
                        min-height: 40px;
                        height: 40px;
                        border: 1px solid rgb(187, 187, 187);
                        padding: 0 10px;
                        border-radius: 5px;
                    }

                    .active-input {
                        border-bottom: 2px solid @primary-color;
                    }
                }
            }

            .message-container {
                min-height: 0;
                max-height: 40px;
                height: auto;
                margin: 5px 0;

                p {
                    margin: 0;
                    font-size: 20px;
                }
            }

            .password-actions-row {
                .controls-buttons {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    margin: 20px auto;
                    width: 100%;

                    button {
                        width: 50%;
                        margin: 0 10px;
                    }
                }

                #android-keyboard {
                    margin: 0;
                }

                .new-password-container {
                    display: flex;
                    justify-content: center;
                    margin: 10px 0;
                }
            }
        }
    }
}

@media (orientation: landscape) and (max-width: 1025px) {
    .password-login-container {
        .container {
            .form {
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: flex-end;
                justify-content: center;
                gap: 12px;
                width: 100%;

                .config-item {
                    flex: 1 1 0;
                    min-width: 0;
                    margin-bottom: 0;

                    label {
                        margin: 4px 0 6px 0;
                    }

                    .div-input-android {
                        width: 100%;
                        height: 60px;
                    }
                }
            }

            .message-container {
                margin: 6px 0;
                min-height: 24px;
                font-size: 20px;
            }

            .password-actions-row {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                align-items: stretch;
                gap: 6px 8px;
                margin: 8px 0 10px;

                .controls-buttons {
                    display: contents;
                }

                .new-password-container {
                    display: contents;
                }

                .controls-buttons > button:first-child {
                    order: 1;
                    flex: 1 1 0;
                    min-width: 0 !important;
                    width: auto !important;
                    margin: 0 4px;
                }

                .controls-buttons > button:nth-child(2) {
                    order: 3;
                    flex: 1 1 0;
                    min-width: 0 !important;
                    width: auto !important;
                    margin: 0 4px;
                }

                .new-password-container .new-login-button {
                    order: 2;
                    flex: 1 1 0;
                    min-width: 0 !important;
                    width: auto !important;
                    margin: 0 4px;
                }

                #android-keyboard {
                    order: 4;
                    flex-basis: 100%;
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }
}

@media (orientation: landscape) and (min-width: 1026px) and (max-width: 1367px) {
    .password-login-container {
        .container {
            .form {
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: flex-end;
                justify-content: center;
                gap: 16px;
                width: 100%;

                .config-item {
                    flex: 1 1 0;
                    min-width: 0;
                    margin-bottom: 0;

                    label {
                        margin: 6px 0 8px 0;
                    }

                    .div-input-android {
                        width: 100%;
                        height: 50px;
                    }
                }
            }

            .message-container {
                margin: 8px 0;
                min-height: 30px;
                font-size: 22px;
            }

            .password-actions-row {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                align-items: stretch;
                gap: 8px 10px;
                margin: 10px 0 12px;

                .controls-buttons {
                    display: contents;
                }

                .new-password-container {
                    display: contents;
                }

                .controls-buttons > button:first-child {
                    order: 1;
                    flex: 1 1 0;
                    min-width: 0 !important;
                    width: auto !important;
                    margin: 0 4px;
                }

                .controls-buttons > button:nth-child(2) {
                    order: 3;
                    flex: 1 1 0;
                    min-width: 0 !important;
                    width: auto !important;
                    margin: 0 4px;
                }

                .new-password-container .new-login-button {
                    order: 2;
                    flex: 1 1 0;
                    min-width: 0 !important;
                    width: auto !important;
                    margin: 0 4px;
                }

                #android-keyboard {
                    order: 4;
                    flex-basis: 100%;
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }
}

@media (orientation: landscape) and (min-width: 1368px) {
    .password-login-container {
        .container {
            .form {
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: flex-end;
                justify-content: center;
                gap: 20px;
                max-width: 1200px;
                margin-left: auto;
                margin-right: auto;

                .config-item {
                    flex: 1 1 0;
                    min-width: 0;
                    margin-bottom: 0;

                    label {
                        margin: 6px 0 10px 0;
                    }

                    .div-input-android {
                        width: 100%;
                    }
                }
            }

            .message-container {
                margin: 10px 0;
                font-size: 24px;
            }

            .password-actions-row {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                align-items: stretch;
                gap: 8px 12px;
                margin: 12px 0 14px;

                .controls-buttons {
                    display: contents;
                }

                .new-password-container {
                    display: contents;
                }

                .controls-buttons > button:first-child {
                    order: 1;
                    flex: 1 1 0;
                    min-width: 0 !important;
                    width: auto !important;
                    margin: 0 4px;
                }

                .controls-buttons > button:nth-child(2) {
                    order: 3;
                    flex: 1 1 0;
                    min-width: 0 !important;
                    width: auto !important;
                    margin: 0 4px;
                }

                .new-password-container .new-login-button {
                    order: 2;
                    flex: 1 1 0;
                    min-width: 0 !important;
                    width: auto !important;
                    margin: 0 4px;
                }

                #android-keyboard {
                    order: 4;
                    flex-basis: 100%;
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/consumerLogin/ConsumerLoginPassword.vue